import * as React from 'react';

import {typography, TypographyName} from '../../theme';

type TextTag =
  | 'p'
  | 'span'
  | 'div'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'label'
  | 'li';

type TextProps = {
  variant: TypographyName;
  as?: TextTag;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

export const Text = ({
  variant,
  as: Tag = 'p',
  className = '',
  style,
  children,
}: TextProps) => (
  <Tag className={`${typography[variant]} ${className}`.trim()} style={style}>
    {children}
  </Tag>
);
